<template>
  <div class="content">
    <div class="content__wrapper">
      <img :src="`${$root.cdnUrl}assets/sad-face.svg`">
      <h2 class="content__title">
        Bu Sayfayı Görebilmek için Statünüz Uygun Değildir
      </h2>
      <p class="content__description">
        Satıcı statünüz <strong>Pasif</strong> olduğundan bu sayfayı
        göremezsiniz.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplierStatusPage',
};
</script>

<style scoped lang="scss">
.content {
  background: var(--white);
  margin: 0 1.5rem;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 526px;
  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1.25rem;
  }
  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
  }
  &__description {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #273142;
    strong {
      font-weight: 500;
    }
  }
}
</style>
